import React from "react";
import { FormProvider } from "react-hook-form";
import { Create } from "@refinedev/mui";

import { AgreementPlanForm } from "@modules/agreementPlans/components";
import { useAgreementPlanCreateForm } from "./controller";

export const AgreementPlanCreate = React.memo(() => {
  const { methods, handleSubmit, mutateAsync, isPending } = useAgreementPlanCreateForm();

  return (
    <Create
      saveButtonProps={{
        onClick: handleSubmit(mutateAsync as any),
        loading: isPending,
      }}
    >
      <FormProvider {...methods}>
        <AgreementPlanForm />
      </FormProvider>
    </Create>
  );
});
